import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import attentionApi from '@/features/dashboard/attention/api/attentionApi.ts';
import { invalidateAttentionQueries } from '@/utils/invalidateAttentionQueries.ts';

export interface ReopenAttentionFindingsParams {
  findingIds: string[];
  /** Wyjazd, którego panel ma się odświeżyć; brak przy sprawach firmy. */
  tourId?: string;
}

/**
 * Przywrócenie wszystkich spraw wiersza jednym żądaniem — osobne żądanie per
 * sprawa trzymało na backendzie po dwa połączenia z puli na każdą z nich.
 */
export const useReopenAttentionFindings = () => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, ReopenAttentionFindingsParams>({
    mutationFn: ({ findingIds }) =>
      attentionApi.reopenAttentionFindings(findingIds),
    onSuccess: (_, { tourId }) =>
      invalidateAttentionQueries(queryClient, tourId),
    onError: (error) =>
      toast.error('Nie udało się przywrócić sprawy', {
        description: error.message,
      }),
  });
};

export default useReopenAttentionFindings;
